import OidcUserManager from 'oidc-service';
import { APP_ROLES, FLOW_PERMISSIONS } from 'store/enums';
import { lsRemoveDataSignout } from './store';

// Security
const oidcUserManager = new OidcUserManager();

export const userSignIn = (loginHint, state, acrValues) =>
  oidcUserManager.signIn(loginHint, state, acrValues);

export const userSignOut = () => {
  lsRemoveDataSignout();
  oidcUserManager.signOut();
};

export const userSigninRedirectCallback = () => oidcUserManager.signinRedirectCallback();

export const userRole = async () => {
  const role = await oidcUserManager.getRole();
  if (!role) {
    return [];
  }

  if (typeof role === 'string') {
    return [role];
  }

  if (Array.isArray(role)) {
    return role;
  }

  return [];
};

export const userProfile = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile;
};

export const userPartnerId = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.partnerid;
};

export const userName = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.name;
};

export const userContactId = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.contactId;
};

export const userSignedIn = async () => {
  const signedIn = await oidcUserManager.getSignedIn();
  return signedIn;
};

export const userAcessTokenAndType = async () => {
  const token = await oidcUserManager.getAcessTokenAndType();
  return token;
};

export const checkAvailabilityRole = (role, check) => role.some(item => check.indexOf(item) !== -1);

export const userHasAldRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]);
};

export const userHasDeveloperRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_DEVELOPER]);
};

export const userHasOnlyAldRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_ADMIN]);
};

export const userHasPartnerRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.PARTNER_ADMIN, APP_ROLES.PARTNER_USER]);
};

export const checkPermissionsMatch = (userRoles, requiredPermissions) =>
  userRoles.some(role => requiredPermissions.includes(role));

export const getPermissionFlow = async () => {
  const userRoles = await userRole();
  const flowPermissionsAccordingToRole = {};
  Object.keys(FLOW_PERMISSIONS).forEach(key => {
    flowPermissionsAccordingToRole[key.toLocaleUpperCase()] = checkPermissionsMatch(
      userRoles,
      FLOW_PERMISSIONS[key]
    );
  });
  return flowPermissionsAccordingToRole;
};
